import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'filteredList': [],
  'pageSize': 20,
  'pageNumber': 0,
  'urlFile': '',
  'loadButton': false,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const monthClose = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.SUBMIT_EXECUTE_MONTH_CLOSE_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'loadButton': false,
      'values': {...state.values},
    }),
    [ActionTypes.SUBMIT_EXECUTE_MONTH_CLOSE_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'loadButton': true,
    }),
    [ActionTypes.SUBMIT_EXECUTE_MONTH_CLOSE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'loadButton': false,
    }),
    [ActionTypes.FETCHING_MONTH_CLOSE_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MONTH_CLOSE_REPORT]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': [...getPage(action.response.data, 0, state.pageSize)],
      'loading': false,
    }),
    [ActionTypes.FETCHED_MONTH_CLOSE_REPORT_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'pageSize': 20,
      'pageNumber': 0,
      'loading': false,
    }),
    [ActionTypes.DELETE_MONTH_CLOSE_REPORT]: () => ({
      ...state,
      'list': [],
      'filteredList': [],
      'pageSize': 20,
      'pageNumber': 0,
      'loading': false,
      'urlFile': '',
    }),
    [ActionTypes.DELETE_URL]: () => ({
      ...state,
      'urlFile': '',
    }),
    [ActionTypes.CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'filteredList': [...getPage(state.list, action.payload, state.pageSize)],
      'urlFile': '',
    }),
    [ActionTypes.CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'filteredList': [...getPage(state.list, 0, action.payload)],
      'urlFile': '',
    }),

    [ActionTypes.DOWNLOADING_MONTH_CLOSE_REPORT_LIST_FILE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': '',
    }),
  })(state, action);
};
